module.exports = __webpack_public_path__ + "static/media/13.5e8f13f5.jpg";